module.exports = __webpack_public_path__ + "static/media/66.10650482.jpg";